import React, { useEffect } from 'react';
import './App.css';
import Typewriter from "typewriter-effect";
import AOS from 'aos';
import 'aos/dist/aos.css';

import logo from './logo.svg';
import PrinceLogo from './images/Princelogo.png';
import sql from './images/sql.jpg';
import tailwind from './images/tailwind.png';
import html from './images/html.png';
import css from './images/css.png';
import Api from './images/Api.png';
import js from './images/js.png';
import jq from './images/jq.png';
import figma from './images/figma.png';
import CSharp from './images/CSharp.svg';
import react from './images/react.png'; 
import Resume from './images/Prince_Gupta_Resume.pdf';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="main-container">
      
      {/* LEFT SECTION */}
      <div className="left-section" data-aos="fade-right">
        <h3>HELLO</h3>
        <h1>
          {"I  Am Prince Gupta "}
          <span style={{ color: "#3F51B5" }}>
            <Typewriter
              options={{
                strings: [
                  "I AM WEB DEVELOPER",
                  "I AM DESIGNER",
                  "I AM Software Developer",
                  "I AM Ui/Ux Designer",
                  "I AM blender model and animation"
                ],
                autoStart: true,
                loop: true,
                delay: 75,
                deleteSpeed: 50,
                pauseFor: 1500,
              }}
            />
          </span>
        </h1>
        <p>WEB DEVELOPER | WEB DESIGNER</p>

        <div className="buttons">
          <a href="https://princeguptaportfolios.netlify.app/" className="btn hire">HIRE ME</a>
          <a
            href={Resume}
            className="btn download"
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            DOWNLOAD CV
          </a>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="right-section" data-aos="fade-left">
        <div className="profile-container">
          <img src={PrinceLogo} alt="profile" className="profile-img" />

          <img src={sql} className="icon icon1" alt="SQL" data-aos="zoom-in" data-aos-delay="100" />
          <img src={tailwind} className="icon icon2" alt="Tailwind" data-aos="zoom-in" data-aos-delay="200" />
          <img src={html} className="icon icon3" alt="HTML5" data-aos="zoom-in" data-aos-delay="300" />
          <img src={css} className="icon icon4" alt="CSS3" data-aos="zoom-in" data-aos-delay="400" />
          <img src={js} className="icon icon5" alt="JS" data-aos="zoom-in" data-aos-delay="500" />
          <img src={react} className="icon icon10" alt="React" data-aos="zoom-in" data-aos-delay="600" />
          <img src={jq} className="icon icon6" alt="jQuery" data-aos="zoom-in" data-aos-delay="700" />
          <img src={figma} className="icon icon7" alt="Figma" data-aos="zoom-in" data-aos-delay="800" />
          <img src={CSharp} className="icon icon8" alt="C#" data-aos="zoom-in" data-aos-delay="900" />
          <img src={Api} className="icon icon9" alt="API" data-aos="zoom-in" data-aos-delay="1000" />
        </div>
      </div>
    </div>
  );
}

export default App;
